import JustValidate from 'just-validate'

document.addEventListener('DOMContentLoaded', function () {
	const supportForm = document.getElementById('support-form')

	if (supportForm) {
		const validator = new JustValidate('#support-form')

		validator
			.addField('#contact-name', [{ rule: 'required' }])
			.addField('#contact-phone', [
				{ rule: 'required', message: 'Please enter a valid phone number' },
				{ rule: 'minLength', value: 5, message: 'Please enter a valid phone number' },
				{ rule: 'number', message: 'Please enter a valid phone number' }
			])
			.addField('#contact-email', [{ rule: 'required' }, { rule: 'email' }])
			.addField('#contact-company', [{ rule: 'required' }])
			.addField('#contact-country', [{ rule: 'required' }])
			.addField('#contact-problem-category', [{ rule: 'required' }])
			.addField('#contact-problem', [{ rule: 'required' }])
			.addField('#terms', [{ rule: 'required' }])

		supportForm.addEventListener('submit', function (event) {
			event.preventDefault()

			validator.validate()

			if (validator.isValid) {
				let formData = new FormData(supportForm)
				for (let pair of formData.entries()) {
					console.log(pair[0] + ': ' + pair[1])
				}
			}
		})
	}
})
